import WatchStatusInfo from './WatchStatusInfo';
import { SENDTYPE } from '../../common/Constant';
/**
 *
 * Created Date: 2019-06-25, 10:06:18 (zhenliang.sun)
 * Last Modified: 2019-06-25, 10:28:32 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */

export default class WatchStatusMaker {
  constructor(cidMaker) {
    this.cidMaker = cidMaker;
  }

  make(data) {
    if (!data || data.length === 0) {
      return [];
    }

    let result = [];
    let lastSwitch;
    data.forEach(cue => {
      let temp = cue.content2;
      if (!temp) {
        temp = cue.content;
      }

      let content;
      if (typeof temp === 'string') {
        content = JSON.parse(temp);
      } else {
        content = temp;
      }

      // 使用新switch字段
      if (content.switch !== undefined && content.switch !== lastSwitch && cue.resend !== SENDTYPE.RESEND) {
        let info = new WatchStatusInfo();
        info.open = content.switch;
        info.uniqueID = content['uniqueID'];
        info.createTime = cue['created_at'];
        // console.log(`push new switch: ${content.switch}`);
        result.push(info);
        lastSwitch = content.switch;
      }

      // 开关消息处理
      let commands = content.command;
      // console.log(content.command);
      if (commands) {
        commands.forEach(command => {
          if (command['type'] === 'switchon' || command['type'] === 'switchoff') {
            let info = new WatchStatusInfo();
            info.open = command['type'] === 'switchon';
            info.uniqueID = content['uniqueID'];
            info.createTime = cue['created_at'];
            result.push(info);
            lastSwitch = content.switch;
          }
        });
      }
    });
    // console.log(result);
    return result;
  }
}
